import { Component } from "@eastsideco/salvo-ts";
import { ThemeComponent } from "@/theme/ThemeComponent";

import Swiper, { FreeMode, Mousewheel } from 'swiper';
import 'swiper/css';

Swiper.use([FreeMode, Mousewheel]);

/**
 * Product Details
 */
@Component
export class ProductsCarouselGallery extends ThemeComponent {
    init() {
        const desktopSlidesAttr = Number(this.getAttribute('desktop-slides')) || 3;
        const mobileSlidesAttr = Number(this.getAttribute('mobile-slides')) || 1;
        const carousel = this.querySelector('.products-carousel-gallery') as HTMLElement;

        if (!carousel) { return; }

        const sw = new Swiper(carousel, {
            slidesPerView: mobileSlidesAttr,
            spaceBetween: 16,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            breakpoints: {
                768: {
                    slidesPerView: desktopSlidesAttr,
                    spaceBetween: 45,
                }
            }
        });

        const updateButtonPosition = () => {
            const firstImage = this.querySelector('.product-card__image, .collection-card__image') as HTMLImageElement;
            if (!firstImage) { return; }
            const nextButton = this.querySelector('.swiper-button-next') as HTMLElement;
            const prevButton = this.querySelector('.swiper-button-prev') as HTMLElement;

            if (firstImage && nextButton && prevButton) {
                const imageHeight = firstImage.clientHeight;
                const buttonTop = (imageHeight / 2) + 'px';

                nextButton.style.top = buttonTop;
                prevButton.style.top = buttonTop;
            }
        };

        updateButtonPosition();
        window.addEventListener('resize', updateButtonPosition);
    }
}
